import React from "react";
import { Form, Row } from "react-bootstrap";
import { useIMask } from "react-imask";

const maskOptions = { mask: "(000) 000-0000" };

export default function Phone(props) {
  const handleAccept = (value) => {
    props.onChange && props.onChange({ target: { value: value, id: props.id } });
  };

  const { ref } = useIMask(maskOptions, { onAccept: handleAccept });
  return (
    <>
      <Form.Group as={Row} controlId={props.id} className="mb-3">
        <Form.Label column sm={6} required>
          {props.label}
        </Form.Label>
            <Form.Control
          ref={ref}
          placeholder="(123) 456-7890"
              required
              type="phone"
              pattern=".{14,}"
              maxLength="14"
          value={props.state[props.id] ? props.state[props.id] : ""}
              data-hj-allow
            />
        <Form.Control.Feedback type="invalid">You must provide a valid phone number</Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
